import { ChangeDetectionStrategy, Component, input } from '@angular/core';


@Component({
    selector: 'app-warning-icon',
    templateUrl: './warning-icon.component.html',
    styleUrls: ['./warning-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class WarningIconComponent {
    messageType = input.required<number>();
}
